import { TaskDefinition, TaskExecution, ParentTaskCancellation } from "@core/models/domain/restriction.domain";

export interface RestrictionState {
  taskDefinitions: TaskDefinition[];
  taskExecutions: Record<string, TaskExecution[]>;
  // Timestamp (ms) of the last local mutation per task definition id. While an
  // entry is fresh, a definitions reload cannot overwrite that definition —
  // the backend read model (CQRS) may not have caught up yet.
  recentLocalWrites: Record<string, number>;
  taskDefinitionsLoaded: boolean;
  taskDefinitionLoading: boolean;
  taskDefinitionError: any;
  taskExecutionLoading: boolean;
  taskExecutionError: any;
  parentCancellations: ParentTaskCancellation[];
  parentCancellationsLoading: boolean;
  parentCancellationsError: any;
  schoolParentCancellations: ParentTaskCancellation[];
  schoolParentCancellationsLoading: boolean;
  schoolParentCancellationsError: any;
}

export const initialRestrictionState: RestrictionState = {
  taskDefinitions: [],
  taskExecutions: {},
  recentLocalWrites: {},
  taskDefinitionsLoaded: false,
  taskDefinitionLoading: false,
  taskDefinitionError: null,
  taskExecutionLoading: false,
  taskExecutionError: null,
  parentCancellations: [],
  parentCancellationsLoading: false,
  parentCancellationsError: null,
  schoolParentCancellations: [],
  schoolParentCancellationsLoading: false,
  schoolParentCancellationsError: null,
};